export default __webpack_public_path__ + "static/hugin-22eb992f24b543a137fc0606008d2c26.gif";